import { ShoppingBasket, Home } from "lucide-react";

// The feed is the one tab with no pill in the bar above it, so nothing else on
// screen says where you are. This card is feed-only, so its eyebrow names the
// page — a slot that already existed, which keeps everything below it exactly
// where it was. Literal first: the "Stoop, there it is." pun used to sit here,
// and a pun in the leading line competes with comprehension.
export function HomeHeroCard() {
  return (
    <div className="container mx-auto px-4 pt-3">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-brand-secondary/20 via-brand-secondary/10 to-primary/15 p-4 sm:p-6">
        <div className="relative z-10 flex items-center gap-4">
          <div className="min-w-0 flex-1">
            <span className="inline-flex items-center gap-1 rounded-full bg-brand-secondary/20 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-brand-secondary sm:text-xs">
              <Home className="h-3 w-3" />
              Main feed
            </span>
            <h2 className="mt-2 font-display text-xl font-bold leading-tight tracking-tight text-foreground sm:text-2xl">
              From their stoop to yours.
            </h2>
            <p className="mt-1.5 text-sm leading-snug text-muted-foreground sm:text-base">
              Fresh produce, baked goods and artisan picks from neighbors on your block.
            </p>
          </div>
          <div className="flex flex-shrink-0 items-center justify-center rounded-2xl bg-brand-secondary/25 p-3 sm:p-4">
            <ShoppingBasket className="h-9 w-9 text-brand-secondary sm:h-10 sm:w-10" strokeWidth={1.6} />
          </div>
        </div>
      </div>
    </div>
  );
}
